import { Http } from '@/lib/http';
export class AccountProductSettingsService extends Http {
  constructor() {
    super();
    this.endpoint = 'onboarder/settings/products/';
  }
  getProducts() {
    return this.httpClient().get(`${this.endpoint}`);
  }
  createProduct(source) {
    return this.httpClient().post(`${this.endpoint}`, source);
  }
  updateProduct(id, source) {
    return this.httpClient().patch(`${this.endpoint}${id}`, source);
  }
}
